<template lang="pug">
    div.pl-md-5.pr-md-5.pb-md-5.width-100-percent.brown.lighten-5(style="margin-top: 0px !important;")

        .text-center(v-if="isLoading || teamScopeLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        v-row(v-else dense style="height: 100vh;" ref="mainOverviewRowRef")
            v-col(cols="12" sm="9")
                TaskBoxes(
                    :sheet-height="rowBoxesHeight"
                    :current-base-dashboard-summary="currentBaseDashboardSummary"
                    :team-scope-empty-message="teamScopeEmptyMessage"
                )

                Inbound(
                    :sheet-height="rowBoxesHeight"
                    :calls-waiting="callsWaiting"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :team-scope-empty-message="teamScopeEmptyMessage"
                )

                GoalsBanner#goals-banner(
                    :sheet-height="rowBoxesHeight"
                    @goal-update="handleWindowResize"
                )

                v-sheet.mt-2.overflow-y-auto(
                    v-bind:style="{ height: mainSheetHeight + 'px' }"
                    color="white"
                    elevation="2"
                    rounded
                )
                    AgentIndex.pa-4(
                        :agents="agents"
                        :filter-obj="filterObj"
                        :teams="teams"
                    )

            v-col(cols="12" sm="3")
                Results(
                    :live-dashboard-inbound-calls-enabled="liveDashboardInboundCallsEnabled"
                    :set-as-call-without-customer="setAsCallWithoutCustomer"
                    :set-current-call="setCurrentCall"
                    :set-current-campaign-customer="setCurrentCampaignCustomer"
                    :set-current-web-rtc-participant="setCurrentWebRtcParticipant"
                    :set-current-web-rtc-session="setCurrentWebRtcSession"
                    :set-supervisor-role="setSupervisorRole"
                    :sheet-height="resultsSheetHeight"
                    :calls-waiting="callsWaiting"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :hourly-dashboard-summaries="hourlyDashboardSummaries"
                    :team-scope-empty-message="teamScopeEmptyMessage"
                )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import GoalsBanner from '@/components/dashboards/live/overview/goals_banner.vue';
    import AgentIndex from '@/components/dashboards/live/agents/agent_index.vue';
    import Inbound from '@/components/dashboards/live/overview/inbound.vue';
    import Results from '@/components/dashboards/live/overview/results.vue';
    import TaskBoxes from '@/components/dashboards/live/overview/task_boxes.vue';

    export default Vue.extend({
        data() {
            return {
                drawer: null,
                isLoading: false,
                mainSheetHeight: null,
                resultsSheetHeight: null,
                rowBoxesHeight: null,
            }
        },
        methods: {
            handleWindowResize() {

                // Declare constants
                const tabsHeight = 0;
                const topHeader = 64;
                const bannerHeight = 57;
                const sheetPx = 8;
                const bottomPx = 12;
                const threeSheetMarginPx = 16;

                // Calcuate
                this.rowBoxesHeight = 100;
                let goalsMarginPx = 0;
                const goalsBannerHeight = (document?.getElementById('goals-banner')?.getBoundingClientRect()?.height || 0);
                if (goalsBannerHeight > 0) {
                    goalsMarginPx = 8;
                }

                this.resultsSheetHeight = this.$refs.mainOverviewRowRef?.clientHeight - topHeader - tabsHeight - bannerHeight - sheetPx - bottomPx;
                this.mainSheetHeight = this.resultsSheetHeight - (this.rowBoxesHeight * 2) - goalsBannerHeight - goalsMarginPx - threeSheetMarginPx;
            },
            setHtmlOverflow(value) {
                const htmlTag = document.getElementsByTagName('html')[0];
                if (!!htmlTag) {

                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');

                    // If hidden, need to scroll back to top
                    if (value === "hidden") {
                        window.scrollTo(0, 0);
                        htmlTag.classList.add('overflow-y-hidden');

                    } else if(value === "scroll"){
                        htmlTag.classList.add('overflow-y-scroll');
                    }
                }
                return;
            },
        },
        computed: {
        },
        components: {
            GoalsBanner,
            AgentIndex,
            Inbound,
            Results,
            TaskBoxes,
        },
        props: {
            agents: Array,
            callsWaiting: Array,
            currentBaseDashboardSummary: Object,
            currentDayDashboardSummary: Object,
            currentUser: Object,
            filterObj: Object,
            hourlyDashboardSummaries: Array,
            liveDashboardInboundCallsEnabled: Boolean,
            setAsCallWithoutCustomer: Function,
            setCurrentCall: Function,
            setCurrentCampaignCustomer: Function,
            setCurrentWebRtcParticipant: Function,
            setCurrentWebRtcSession: Function,
            setSupervisorRole: Function,
            teamScopeEmptyMessage: String,
            teamScopeLoading: Boolean,
            teams: Array,
        },
        destroyed() {
            this.setHtmlOverflow("scroll");
            window.removeEventListener('resize', this.handleWindowResize);
        },
        created() {
        },
        mounted() {
            this.setHtmlOverflow("hidden");
            window.addEventListener('resize', this.handleWindowResize);
            this.handleWindowResize();
        },
    });
</script>

<style lang="scss" scoped>
</style>
